import React, { useState, useEffect } from 'react';
import api from '../services/apiService';
import { Helmet } from 'react-helmet';

const CustomerCategoryForm = () => {
  const [name, setName] = useState('');
  const [color, setColor] = useState('');
  const [description, setDescription] = useState('');
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  // Edit-States
  const [editingId, setEditingId] = useState(null);
  const [editedName, setEditedName] = useState('');
  const [editedColor, setEditedColor] = useState('');
  const [editedDescription, setEditedDescription] = useState('');

  const fetchCategories = async () => {
    try {
      const res = await api.get('/customerCategories');
      setCategories(res.data);
    } catch (e) {
      alert('Fehler beim Laden der Kategorien');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchCategories(); }, []);

  // Hinzufügen
  const handleAdd = async () => {
    if (!name) return alert('Bitte Name eingeben!');
    try {
      await api.post('/customerCategories', { name, color, description });
      setName('');
      setColor('');
      setDescription('');
      fetchCategories();
    } catch {
      alert('Fehler beim Anlegen');
    }
  };

  // Löschen
  const handleDelete = async id => {
    if (!window.confirm('Wirklich löschen?')) return;
    try {
      await api.delete(`/customerCategories/${id}`);
      setCategories(categories.filter(cat => cat.id !== id));
    } catch {
      alert('Fehler beim Löschen');
    }
  };

  // Edit starten
  const handleEdit = cat => {
    setEditingId(cat.id);
    setEditedName(cat.name);
    setEditedColor(cat.color || '');
    setEditedDescription(cat.description || '');
  };

  // Edit abbrechen
  const handleCancelEdit = () => {
    setEditingId(null);
    setEditedName('');
    setEditedColor('');
    setEditedDescription('');
  };

  // Edit speichern
  const handleUpdate = async id => {
    try {
      await api.put(`/customerCategories/${id}`, {
        name: editedName,
        color: editedColor,
        description: editedDescription
      });
      setEditingId(null);
      fetchCategories();
    } catch {
      alert('Fehler beim Aktualisieren');
    }
  };

  if (loading) return <div>Daten werden geladen...</div>;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '700px' }}>
        <Helmet>
          <title>Kundenkategorien verwalten</title>
        </Helmet>
        <h2 style={{ textAlign: 'center', marginBottom: 20 }}>Kundenkategorien verwalten</h2>

        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 2fr auto', gap: 10, marginBottom: 20 }}>
          <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Name" />
          <input type="color" value={color} onChange={e => setColor(e.target.value)} placeholder="Farbe" />
          <input type="text" value={description} onChange={e => setDescription(e.target.value)} placeholder="Beschreibung" />
          <button onClick={handleAdd} style={{ background: '#28a745', color: '#fff', borderRadius: 4 }}>Hinzufügen</button>
        </div>

        <ul style={{ listStyle: 'none', padding: 0 }}>
          {categories.map(cat => (
            <li key={cat.id} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 2fr auto', gap: 10, alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #eee' }}>
              {editingId === cat.id ? (
                <>
                  <input type="text" value={editedName} onChange={e => setEditedName(e.target.value)} />
                  <input type="color" value={editedColor} onChange={e => setEditedColor(e.target.value)} />
                  <input type="text" value={editedDescription} onChange={e => setEditedDescription(e.target.value)} />
                  <div>
                    <button onClick={() => handleUpdate(cat.id)} style={{ marginRight: 5 }}>✅</button>
                    <button onClick={handleCancelEdit}>✖️</button>
                  </div>
                </>
              ) : (
                <>
                  <span>{cat.name}</span>
                  <span>
                    {cat.color ? (
                      <span style={{
                        display: 'inline-block', width: 20, height: 20, background: cat.color, borderRadius: 4, border: '1px solid #ccc'
                      }} />
                    ) : '—'}
                  </span>
                  <span>{cat.description}</span>
                  <div>
                    <button onClick={() => handleEdit(cat)} style={{ marginRight: 5, background: '#007bff', color: '#fff', borderRadius: 4 }}>Bearbeiten</button>
                    <button onClick={() => handleDelete(cat.id)} style={{ background: '#dc3545', color: '#fff', borderRadius: 4 }}>Löschen</button>
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CustomerCategoryForm;
